import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchUnreadCount } from '../api/messages';

const unreadCountFetchAtom = atom(async () => {
    return await fetchUnreadCount();
});

const unreadCountLoadableAtom = loadable(unreadCountFetchAtom);
const unreadCountOverrideAtom = atom(null);

export const unreadMessageCountAtom = atom(
    (get) => {
        const override = get(unreadCountOverrideAtom);
        if (override !== null) return override;
        const fetched = get(unreadCountLoadableAtom);
        return fetched.state === 'hasData' ? fetched.data : 0;
    },
    (get, set, update) => {
        const override = get(unreadCountOverrideAtom);
        let current;
        if (override !== null) {
            current = override;
        } else {
            const fetched = get(unreadCountLoadableAtom);
            current = fetched.state === 'hasData' ? fetched.data : 0;
        }
        set(unreadCountOverrideAtom, typeof update === 'function' ? update(current) : update);
    }
);
